import * as apiCommon from '@/api/common'
import * as apiContract from '@/api/contract'
import * as _ from 'lodash'
import { getDataURL } from '@/util/common'


const getDefaultState = () => {
  const product = {
    name: '',
    code: '',
    classification: null,
    period_start: null,
    period_end: null,
    release_flg: 0
  }
  const user = {
    id: null,
    name: '',
    file_id: null,
    auth: 0,
    status: 0,
    products: [product],
    note_number: 0
  }
  return {
    users: [user],
    currentUserId: null
  }
}

const users = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    sortedNoteNum: (state) => {
      return _.orderBy(state.users, ['status', 'note_number'], ['asc', 'desc'])
    },
    sortedLoginIdAndAuth: (state, getters, rootState) => {
      return _.orderBy(state.users, [user => user.id === rootState.profile.id, 'auth'], ['desc', 'desc'])
    },
    getCurrentUser: (state, getters, rootState) => {
      return _.find(state.users, user => user.id === state.currentUserId)
    }
  },
  mutations: {
    // データをstateに保存
    setAllData(state, payload) {
      const { data } = payload
      state.users = data.users
    },
    setUserImage(state, payload) {
      const { user } = payload
      const index = state.users.findIndex((u) => u.id === user.id)
      const tmpUsers = state.users
      tmpUsers[index] = user
      state.users = [...tmpUsers]
    },
    // データを初期状態に戻す
    resetData(state) {
      Object.assign(state, getDefaultState())
    },
    setCurrentUser(state, id) {
      state.currentUserId = id
    },
    startUserStatus(state, index) {
      const prev = state.users[index]
      prev.status = 1
      state.users.splice(index, 1, prev)
    },
    stopUserStatus(state, index) {
      const prev = state.users[index]
      prev.status = 0
      state.users.splice(index, 1, prev)
    },
    resetUserData(state, index) {
      const prev = state.users[index]
      prev.products = []
      state.users.splice(index, 1, prev)
    }
  },
  actions: {
    async getUsersData({ commit, dispatch }) {
      await apiContract
        .getUsers()
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            commit('setAllData', { data })


            // 画像設定しているユーザーのアイコンを設定する 
            _.forEach(_.filter(data.users, list => list.file_id && list.file_id > 0), (list) => {
              dispatch('getFile', list.file_id, { root: true }).then(res => {
                const user = { ...list, image: res.dataUrl }
                commit('setUserImage', { user })
              })
            })
          } else {

            return data
          }
        })
    },
    async setCurrentUser({ commit }, id) {
      await commit('setCurrentUser', id)
    },
    /**
     * 利用者状態更新APIを開始(status=0)で呼び出し、成功時に利用者の状態を変更
     */
    async startUser({ commit, state }) {
      const params = {
        id: state.currentUserId,
        status: 0
      }
      const res = await apiContract
        .updateUserStatus(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            const index = _.findIndex(state.users, user => user.id === state.currentUserId)
            commit('startUserStatus', index)

            return data
          } else {

            return data
          }
        })
        .catch(err => {
          Promise.reject(err)
        })

      return res
    },
    /**
     * 利用者状態更新APIを停止(status=1)で呼び出し、成功時に利用者の状態を変更 
     */
    async stopUser({ commit, state }) {
      const params = {
        id: state.currentUserId,
        status: 1
      }
      const res = await apiContract
        .updateUserStatus(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            const index = _.findIndex(state.users, user => user.id === state.currentUserId)
            commit('stopUserStatus', index)

            return data
          } else {

            return data
          }
        })

      return res
    },
    /**
     * 利用者リセットAPIを呼び出し
     */
    async resetUser({ commit, state }) {
      const params = {
        id: state.currentUserId
      }
      const res = await apiContract
        .resetUser(params)
        .then(response => {
          const data = response.data
          if (data.status === 0) {
            const index = _.findIndex(state.users, user => user.id === state.currentUserId)
            commit('resetUserData', index)

            return data
          } else {

            return data
          }
        })
      
      return res
    },
    /**
     * 利用者更新APIを呼び出し
     */
    async updateUser({ commit, state }, changeUser) {
      const params = {
        id: state.currentUserId,
        name: changeUser.name,
        email: changeUser.email,
        email_confirm: changeUser.emailConfirm
      }

      const res = await apiContract
        .updateUser(params)
        .then(response => {
          const data = response.data
          return data
        })
        .catch(err => {
          Promise.reject(err)
        })

      return res
    },
    async bulkUpdateUser({ commit }, users) {
      const params = {
        data: users
      }
      const res = await apiContract
        .updateUsersInBulk(params)
        .then(response => {
          const data = response.data
          return data
        })

      return res
    },
    async addUser({ commit }, user) {
      const params = {
        name: user.name,
        auth: user.auth,
        email: user.email,
        email_confirm: user.emailConfirm
      }
      const res = await apiContract
        .addUser(params)
        .then(response => {
          const data = response.data
          return data
        })

      return res
    }
  }
}
// updateUser
export default users
